import Vue from 'vue'
import './plugins/fontawesome'

import "@babel/polyfill";
import App from './App.vue'
import { store } from "./store";
import router from './router'
import VueI18n from 'vue-i18n';
import Snotify, { SnotifyPosition } from "vue-snotify";

import de from '@/locales/de';
import dk from '@/locales/dk';
import en from '@/locales/en';
import es from '@/locales/es';
import fi from '@/locales/fi';
import fr from '@/locales/fr';
import gr from '@/locales/gr';
import it from '@/locales/it';
import nl from '@/locales/nl';
import no from '@/locales/no';
import pt from '@/locales/pt';
import ru from '@/locales/ru';
import se from '@/locales/se';
import ua from '@/locales/ua';

// CEE region
import pl from '@/locales/pl';
import cz from '@/locales/cz';
import sk from '@/locales/sk';
import hu from '@/locales/hu';
import ro from '@/locales/ro';

import inject_defaults from '@/locales/defaults';

Vue.config.productionTip = false;

const snotifyOptions = {
  toast: {
    position: SnotifyPosition.rightTop,
    showProgressBar: false,
    titleMaxLength: 150,
    timeout: 4000,
    animation: { enter: "fadeIn", exit: "fadeOut", time: 200 }
  }
};

Vue.use(VueI18n);
Vue.use(Snotify, snotifyOptions);

export const i18n = new VueI18n({
  locale: 'en',
  messages: {
    de: inject_defaults({...de}),
    dk: inject_defaults({...dk}),
    en: inject_defaults({...en}),
    es: inject_defaults({...es}),
    fi: inject_defaults({...fi}),
    fr: inject_defaults({...fr}),
    gr: inject_defaults({...gr}),
    it: inject_defaults({...it}),
    nl: inject_defaults({...nl}),
    no: inject_defaults({...no}),
    pt: inject_defaults({...pt}),
    ru: inject_defaults({...ru}),
    se: inject_defaults({...se}),
    ua: inject_defaults({...ua}),

    // CEE region
    pl: inject_defaults({...pl}),
    cz: inject_defaults({...cz}),
    hu: inject_defaults({...hu}),
    ro: inject_defaults({...ro}),
    sk: inject_defaults({...sk})
  }
});


new Vue({
  i18n,
  store,
  router,
  render: h => h(App)
}).$mount('#app');
